import { useStore } from "@/store";

export function getVardformFromValue(vardform: any) {
    const store = useStore();
    if (typeof vardform === "number") {
        return store.getters["operation/vardform/vardformById"]({ id: vardform });
    }
    if (vardform && typeof vardform === "object") {
        const id = vardform.value ?? vardform.id;
        if (typeof id === "number") {
            return store.getters["operation/vardform/vardformById"]({ id });
        }
    }
    return vardform;
}
